import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UseTitle from "../../Hooks/UseTitle";
import KidzoneCover from "../../../Assets/Hompage/playGround/playGround-cover.jpg";
import KidzoneCoverMobile from "../../../Assets/Hompage/playGround/playGround (4).jpg";
const Kidzone = () => {
  UseTitle("Kids Zone");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div>
      <div className="bg-gray-100">
        <div className="pt-16 md:pt-0 md:block hidden">
          <img src={KidzoneCover} alt="KidsZone" className="w-full" />
        </div>
        <div className="pt-16 md:pt-0 md:hidden block">
          <img src={KidzoneCoverMobile} alt="KidsCover" className="w-full" />
        </div>
        <div className="max-w-screen-xl mx-auto">
          <div className="py-10 md:px-20 px-5 bg-white">
            <h2 className="text-[50px] text-gray-800 text-center md:text-start">
              Kids Zone
            </h2>

            <div className="py-20">
              <p className="text-[16px]">
                In our exciting Kids zone, where kids can let loose, play, and
                have fun! Our Kids zone features a variety of different Kids
                equipment like a spacious and well-maintained ground that
                provides the perfect space for kids to run around and Kids. This
                open space is the ideal spot for kids to burn off some energy
                and get moving. Next, we have a classic swing that is sure to
                bring a smile to any child's face, and is secured firmly in the
                ground to provide a stable and secure Kids experience. We also
                have an exciting slider that will give your child an adrenaline
                rush as they speed down it. And last but not least, we have a
                challenging and exciting monkey bar that will put your child's
                strength and agility to the test. With our range of Kids
                equipment and safe, well-maintained environment, you can be sure
                that your kids will have a blast while staying safe and secure.
              </p>
            </div>
          </div>

          <div className="md:px-0 px-5">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlaySpeed={2000}
              autoPlay={true}
              customTransition="all .5"
            >
              <div>
                <img
                  src="https://i.ibb.co/BtcHDSW/322710165-1133924840598116-4947839460485297833-n.jpg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div>
                <img
                  src="https://i.ibb.co/Wx5TLMb/299439128-169163652322192-962413345981293355-n.jpg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div>
                <img
                  src="https://i.ibb.co/5FdpHtn/playzone-3.jpg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div>
                <img
                  src="https://i.ibb.co/rMSfhsz/playzone-4.jpg"
                  alt=""
                  className="w-full"
                />
              </div>
            </Carousel>
          </div>
          <div className="py-20">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              <div className="flex justify-center items-start"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kidzone;
